import { FormlyFieldConfigMap } from './formly-field-config.map';
import {Revotes} from '@emm/core/models/revotes.model';

const masterMenuSystemPlaceHolder = 'Search Revotes';

export const masterMenuFilterFieldMap: FormlyFieldConfigMap<Revotes> = {
  name: () => ({
    key: 'name',
    type: 'input',
    wrappers: ['form-field-filter'],
    templateOptions: {
      label: 'Revote Name',
      placeholder: masterMenuSystemPlaceHolder,
    },
  })
};
